/**
 * CTA Background Parallax
 *
 * Standardmäßig läuft eine CSS-Animation (cta-bg-drift) die den Hintergrund
 * kontinuierlich bewegt. Sobald die Maus aktiv ist, übernimmt JS den Effekt
 * via sanftem Lerp – die CSS-Animation wird dabei deaktiviert (cta--js-driven).
 * Nach IDLE_TIMEOUT ms Maus-Inaktivität fällt das Element zur CSS-Animation zurück.
 *
 * STRENGTH     – max. Verschiebung in Prozent um den Mittelpunkt
 * LERP         – Interpolationsfaktor 0–1 (kleiner = träger/weicher)
 * IDLE_TIMEOUT – ms ohne Mausbewegung bevor CSS-Animation wieder übernimmt
 */

const STRENGTH    = 8
const LERP        = 0.06
const IDLE_TIMEOUT = 3000
const JS_CLASS    = 'cta--js-driven'

export function ctaParallax() {
	const ctas = document.querySelectorAll('.cta')
	if (!ctas.length) return

	// Zielwerte aus mousemove
	let targetX  = 50
	let targetY  = 50

	// Aktuelle (interpolierte) Werte
	let currentX = 50
	let currentY = 50

	let isActive  = false
	let idleTimer = null

	function setActive() {
		if (!isActive) {
			isActive = true
			ctas.forEach(el => el.classList.add(JS_CLASS))
		}
		clearTimeout(idleTimer)
		idleTimer = setTimeout(setIdle, IDLE_TIMEOUT)
	}

	function setIdle() {
		isActive = false
		// Custom Properties entfernen, damit CSS-Animation wieder greift
		ctas.forEach(el => {
			el.classList.remove(JS_CLASS)
			el.style.removeProperty('--cta-bg-x')
			el.style.removeProperty('--cta-bg-y')
		})
		// Interpolation zurücksetzen für nächste Aktivierung
		currentX = 50
		currentY = 50
		targetX  = 50
		targetY  = 50
	}

	// Mausposition nur speichern – kein DOM-Zugriff hier
	window.addEventListener('mousemove', e => {
		const x = (e.clientX / window.innerWidth  - 0.5) * 2
		const y = (e.clientY / window.innerHeight - 0.5) * 2

		targetX = 50 - x * STRENGTH
		targetY = 50 - y * STRENGTH

		setActive()
	}, { passive: true })

	// rAF-Loop: DOM-Write max. 1× pro Frame, nur wenn JS aktiv ist
	function tick() {
		if (isActive) {
			currentX += (targetX - currentX) * LERP
			currentY += (targetY - currentY) * LERP

			if (Math.abs(targetX - currentX) > 0.01 || Math.abs(targetY - currentY) > 0.01) {
				const x = `${currentX.toFixed(3)}%`
				const y = `${currentY.toFixed(3)}%`

				ctas.forEach(cta => {
					cta.style.setProperty('--cta-bg-x', x)
					cta.style.setProperty('--cta-bg-y', y)
				})
			}
		}

		requestAnimationFrame(tick)
	}

	requestAnimationFrame(tick)
}
